<template>
  <div class="addGatewayManagement-page">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <div class="title-back">
              <h4>添加通信网关</h4>
              <p class="backBth" @click="canlan">
                <i class="el-icon-caret-left"></i>
                <span>返回</span>
              </p>
            </div>
          </div>
        </div>
        <div class="table-content" style="width: 800px">
          <el-form
            label-position="right"
            label-width="130px"
            :model="formLabelAlign"
            :rules="rules"
            ref="formLabelAlign"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="设备名称：" prop="gatewayName">
                  <el-input
                    v-model="formLabelAlign.gatewayName"
                    placeholder="请输入设备名称"
                    maxlength="20"
                    clearable
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备编码：" prop="gatewayCode">
                  <el-input
                    v-model="formLabelAlign.gatewayCode"
                    placeholder="请输入设备编码"
                    maxlength="20"
                    clearable
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="网关类型：" prop="type">
                  <el-select
                    v-model="formLabelAlign.type"
                    placeholder="请选择网关类型"
                    class="inputW"
                  >
                    <el-option
                      v-for="item in list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="协议类型：" prop="protocolType">
                  <el-select
                    v-model="formLabelAlign.protocolType"
                    placeholder="请选择协议类型"
                    class="inputW"
                  >
                    <el-option
                      v-for="item in protocolTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="所属分组：" prop="groupId">
                  <el-cascader
                    class="inputW"
                    @change="changeTreeItem"
                    :show-all-levels="false"
                    v-model="formLabelAlign.groupId"
                    :options="departList"
                    :props="optionProps"
                    clearable
                    placeholder="请选择所属分组"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="数据传输类型： " prop="dataTransferType">
                  <el-select
                    v-model="formLabelAlign.dataTransferType"
                    placeholder="请选择数据传输类型"
                    class="inputW"
                  >
                    <el-option
                      v-for="item in dataTransferTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="心跳包：">
              <el-input
                v-model="formLabelAlign.heartBeat"
                maxlength="20"
                clearable
                placeholder="请输入心跳包"
                style="width: 640px"
              ></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="云平台IP地址：" prop="serverIp">
                  <el-input
                    v-model="formLabelAlign.serverIp"
                    maxlength="60"
                    clearable
                    placeholder="请输入云平台IP地址"
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="云平台端口号：" prop="serverPort">
                  <el-input-number
                    placeholder="请输入云平台端口号"
                    v-model="formLabelAlign.serverPort"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="命令下发间隔："
                  prop="cmdIssueIntervalTime"
                >
                  <el-input-number
                    placeholder="请输入命令下发间隔(毫秒)"
                    v-model="formLabelAlign.cmdIssueIntervalTime"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产日期：" prop="pdate">
                  <el-date-picker
                    v-model="formLabelAlign.pdate"
                    type="date"
                    placeholder="年/月/日"
                    class="inputW"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="采集数据间隔：">
                  <el-input-number
                    placeholder="请输入采集数据间隔(秒)"
                    v-model="formLabelAlign.intervalTime"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="心跳包间隔时间：">
                  <el-input-number
                    placeholder="请输入心跳包间隔时间(秒)"
                    v-model="formLabelAlign.heartBeatIntervalTime"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="经度：">
                  <el-input-number
                    placeholder="请输入经度"
                    v-model="formLabelAlign.longitude"
                    :precision="6"
                    :step="1"
                    :min="-99999999"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纬度：">
                  <el-input-number
                    placeholder="请输入纬度"
                    v-model="formLabelAlign.dimension"
                    :precision="6"
                    :step="1"
                    :min="-99999999"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item style="text-align: center">
              <el-button @click="canlan">取 消</el-button>
              <el-button type="primary" @click="submitForm('formLabelAlign')"
                >确 定</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        // 弹框表单验证
        serverPort: [
          { required: true, message: "请输入云平台端口号", trigger: "blur" },
        ],
        serverIp: [
          { required: true, message: "请输入云平台IP地址", trigger: "blur" },
        ],
        gatewayName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        gatewayCode: [
          { required: true, message: "请输入设备编码", trigger: "blur" },
        ],
        paramType: [
          { required: true, message: "请选择参数类型", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择网关类型", trigger: "change" },
        ],
        cmdIssueIntervalTime: [
          {
            required: true,
            message: "请输入命令下发间隔(ms)",
            trigger: "blur",
          },
        ],
        dataTransferType: [
          { required: true, message: "请选择数据传输类型", trigger: "change" },
        ],
        groupId: [
          { required: true, message: "请选择所属分组", trigger: "change" },
        ],
        gatewayId: [
          { required: true, message: "请选择所属网关", trigger: "change" },
        ],
        modelRuleDeviceId: [
          { required: true, message: "请选择模板类型", trigger: "change" },
        ],
        switchType: [
          { required: true, message: "请选择开关分类", trigger: "change" },
        ],
        protocolType: [
          { required: true, message: "请选择协议类型", trigger: "change" },
        ],
        pdate: [
          { required: true, message: "请选择生产日期", trigger: "change" },
        ],
        intervalTime: [
          { required: true, message: "请输入采集数据间隔", trigger: "blur" },
          {
            pattern: /^[0-9]*$/, //正则
            message: "请输入正确的采集数据间隔",
          },
        ],
        collectTimeout: [
          { required: true, message: "请输入采集超时时间", trigger: "blur" },
          {
            pattern: /^[0-9]*$/, //正则
            message: "请输入正确的采集超时时间",
          },
        ],

        ysAppCode: [
          { required: true, message: "请输入萤石序列号", trigger: "blur" },
        ],
        ysAppKey: [
          { required: true, message: "请输入萤石appKey", trigger: "blur" },
        ],
        ysAppSecret: [
          { required: true, message: "请输入萤石appSecret", trigger: "blur" },
        ],
        playAddr: [
          { required: true, message: "请输入ezopen地址", trigger: "blur" },
        ],
        playM3u8: [
          { required: true, message: "请输入m3u8地址", trigger: "blur" },
        ],
        playRtmp: [
          { required: true, message: "请输入rtmp地址", trigger: "blur" },
        ],
      },
      //数据传输类型 1主动上报 2轮询
      dataTransferTypeList: [
        {
          id: 1,
          name: "主动上报",
        },
        {
          id: "2",
          name: "轮询",
        },
      ],
      protocolTypeList: [
        //协议类型(0：sdk，1：onvif,2：rtsp，3：gb28181）
        {
          id: 0,
          name: "sdk",
        },
        {
          id: 1,
          name: "onvif",
        },
        {
          id: 2,
          name: "rtsp",
        },
        {
          id: 3,
          name: "gb28181",
        },
      ],
      list: [
        //网关类型（1：非休眠网关/2：休眠网关）
        {
          id: 1,
          name: "非休眠网关",
        },
        {
          id: 2,
          name: "休眠网关",
        },
      ],
      departList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
      },
      options: [
        {
          value: "选项1",
          label: "传感树001",
        },
        {
          value: "选项2",
          label: "传感树002",
        },
        {
          value: "选项3",
          label: "传感树004",
        },
        {
          value: "选项4",
          label: "传感树004",
        },
        {
          value: "选项5",
          label: "传感树005",
        },
      ],
      value: "传感树001",
      name: "",
      formLabelAlign: {
        dataTransferType: "",
        gatewayName: "",
        gatewayCode: "",
        groupId: "",
        heartBeat: "",
        heartBeatIntervalTime: "",
        id: "",
        intervalTime: "",
        pdate: "",
        protocolType: "",
        serverIp: "",
        serverPort: "",
        type: "",
        longitude: undefined,
        dimension: undefined,
        cmdIssueIntervalTime: "",
      },
    };
  },
  created() {
    this.getGatewayDER(this.$route.query.id);
    this.id = this.$route.query.id;
    // this.getModelRuleDevices();
    this.getConfigGroupTree();

    // this.saveGateway();
  },
  methods: {
    submitForm(formName) {
      // 提交表单

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
          // console.log('888')
        } else {
          return false;
        }
      });
    },
    //所属分组id
    changeTreeItem(val) {
      this.formLabelAlign.groupId = val[val.length - 1];
    },
    //查询全部设备类型模板
    getModelRuleDevices() {
      this.$api.system
        .getModelRuleDevices()
        .then((res) => {
          if (res.code == 200) {
            this.modelRuleDeviceIdList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询全部通信网关
    getGateways() {
      this.$api.system
        .getGateways()
        .then((res) => {
          if (res.code == 200) {
            this.getGatewaysList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0, //主键id ，根据具体业务进行判定
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询全部设备类型模板
    getModelRuleDevices() {
      this.$api.system
        .getModelRuleDevices()
        .then((res) => {
          if (res.code == 200) {
            this.modelRuleDeviceIdList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 查询控制设备详情
    getGatewayDER(id) {
      if (id == undefined || id == "") {
        return false;
      }
      this.$api.system
        .getGatewayDER(id)
        .then((res) => {
          if (res.code == 200) {
            this.show = true;
            this.formLabelAlign.cmdIssueIntervalTime =
              res.data.cmdIssueIntervalTime;
            this.formLabelAlign.dataTransferType =
              res.data.dataTransferType.toString();
            this.formLabelAlign.groupId = res.data.groupId;
            this.formLabelAlign.modelRuleDeviceId = res.data.modelRuleDeviceId;
            this.formLabelAlign.protocolType = res.data.protocolType;
            this.formLabelAlign.addressBit = res.data.addressBit;
            this.formLabelAlign.gatewayId = res.data.gatewayId;
            this.formLabelAlign.addressBit = res.data.addressBit;
            this.formLabelAlign.collectTimeout = res.data.collectTimeout;
            this.formLabelAlign.dimension = res.data.dimension;
            this.formLabelAlign.groupId = res.data.groupId;
            this.formLabelAlign.intervalTime = res.data.intervalTime;
            this.formLabelAlign.longitude = res.data.longitude;
            this.formLabelAlign.serverIp = res.data.serverIp;
            this.formLabelAlign.paramType = res.data.paramType;
            this.formLabelAlign.pdate = res.data.updateTime;
            this.formLabelAlign.serverPort = res.data.serverPort;
            this.formLabelAlign.id = res.data.id;
            this.formLabelAlign.gatewayName = res.data.gatewayName;
            this.formLabelAlign.type = res.data.type;
            this.formLabelAlign.heartBeatIntervalTime =
              res.data.heartBeatIntervalTime;
            this.formLabelAlign.heartBeat = res.data.heartBeat;
            this.formLabelAlign.gatewayCode = res.data.gatewayCode;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    canlan() {
      // this.$router.go(-1);
      this.$router.push({
        name: "deviceManagement",
        query: {
          currentShow: "second",
          currentShow1: "fourth",
        },
      });
    },
    //提交
    submit() {
      this.saveGateway();
      // this.$router.go(-1);
    },
    zhDatetime(t) {
      if (t == "" || t == null || t == undefined) {
        return "";
      } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : "0" + M;
        D = D > 9 ? D : "0" + D;
        h = h > 9 ? h : "0" + h;
        m = m > 9 ? m : "0" + m;
        s = s > 9 ? s : "0" + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
      }
    },
    // 保存控制设备
    saveGateway() {
      var timer = this.zhDatetime(this.formLabelAlign.pdate);
      if (this.id == undefined) {
        this.id = "";
      }

      var formdata = {
        dataTransferType: this.formLabelAlign.dataTransferType,
        gatewayName: this.formLabelAlign.gatewayName,
        gatewayCode: this.formLabelAlign.gatewayCode,
        type: this.formLabelAlign.type,
        cmdIssueIntervalTime: this.formLabelAlign.cmdIssueIntervalTime,
        intervalTime: this.formLabelAlign.intervalTime,
        pdate: timer,
        longitude: this.formLabelAlign.longitude,
        groupId: this.formLabelAlign.groupId,
        dimension: this.formLabelAlign.dimension,
        heartBeatIntervalTime: this.formLabelAlign.heartBeatIntervalTime,
        heartBeat: this.formLabelAlign.heartBeat,
        serverIp: this.formLabelAlign.serverIp,
        id: this.id,
        serverPort: this.formLabelAlign.serverPort,
        type: this.formLabelAlign.type,
      };

      this.$api.system
        .saveGateway(formdata)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.$router.push({
              name: "deviceManagement",
              query: {
                currentShow: "second",
                currentShow1: "fourth",
              },
            });
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传10张图片`);
    },

    handleAvatarSuccess(res, file) {
      // console.log( res, file );
      if (res.code == 200) {
        this.srcList = [];
        this.show = true;
        this.$forceUpdate();
        this.formLabelAlign.imageURL = res.data;
        this.$toaster.ok(res.msg);

        // console.log(  this.dialogform.image)
        this.imgUpdateProgress = 100;
        setTimeout(() => {
          this.isUpdateSuccess = false;
          this.imgUpdateProgress = 0;
        }, 200);
      }
    },
    handleAvatarProgress(event, file, fileList) {
      // 文件上传时的进度
      this.isUpdateSuccess = true;
      var timer = setInterval(() => {
        this.imgUpdateProgress += 10;
        if (this.imgUpdateProgress >= 90) {
          clearInterval(timer);
        }
      }, 200);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isSize = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 、PNG 格式!");
      }
      if (!isSize) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isSize;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/addGatewayManagement.scss";
li {
  padding-left: 15px;
}
.inputW {
  width: 230px !important;
}
.shujuleix {
  .el-form-item__error {
    width: 120px;
  }
}
</style>